export default __webpack_public_path__ + "static/media/SarahGrady.d08f755d.jpg";